import { render, staticRenderFns } from "./ActivateEquipamentoNotaFiscal.vue?vue&type=template&id=2b4d1c21&"
import script from "./ActivateEquipamentoNotaFiscal.vue?vue&type=script&lang=js&"
export * from "./ActivateEquipamentoNotaFiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports